import { placeholderFile } from '../../utils';
import { Component, ElementRef, Injector, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MakeProvider } from '../abstract-value-accessor/abstract-value-accessor';
import { FileInputBasicComponent } from '../file-input-basic/file-input-basic.component';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  providers: [MakeProvider(FileInputComponent)],
})
export class FileInputComponent extends FileInputBasicComponent {
  @ViewChild('fileUploadField')
  private fileUploadField: ElementRef<HTMLInputElement>;

  @Input()
  errorTexts: { [key: string]: string | (() => string) };

  @Input()
  required: boolean;

  @Input()
  label: string;

  @Input()
  index: number;

  @Input()
  validateOnDirty = false;

  @Input()
  labelIcon: string;

  @Input()
  labelWithColon = true;

  @Input()
  acceptedFileExtensions?: string[];

  @Input()
  descriptionTooltipText: string;

  @Input()
  errorInfoIconTexts: Record<string, string>;

  get acceptedFileExtensionsString(): string {
    if (!this.acceptedFileExtensions) {
      return;
    }

    return this.acceptedFileExtensions.join(',');
  }

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    super.ngOnChanges(simpleChanges);
  }

  uploadFile(): void {
    this.formControl.reset();
    this.markAsDirty();

    this.value = this.fileUploadField.nativeElement.files[0];
  }

  buildTranslationKey(relativeKey: string): string {
    return `openedPlugin.dynamicForm.${relativeKey}`;
  }

  selectFile(): void {
    this.fileUploadField.nativeElement.click();
  }

  writeValue(value: File | string): void {
    if (typeof value === 'string' && !!value) {
      value = new File([], value, { type: placeholderFile });
    }

    super.writeValue(value);
  }
}
